import type {TError} from "modules/types";
import {createAction} from "redux-act";

export const globalError = createAction<unknown>();
export const showGlobalError = createAction<TError>();
export const showGageError = createAction<string>();
export const clearGlobalError = createAction();
